<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import { mapGetters, mapActions, mapState } from "vuex";
import moment from "moment";
import axios from "axios";
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Cash Flow Report",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },
  data() {
    return {
      filterCashflow: {
        title: "",
        datefrom: "",
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        mode: "",
      },
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      rep_total: {
        inc_total: "",
        exp_total: "",
        balance: "",
      },
      fitered_array: [],
      title: "Cash Flow Report",
      items: [
        {
          text: "Account Section",
          href: "#/",
        },
        {
          text: "Cash Flow Report",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        // {
        //   key: "branch",
        //   sortable: true,
        //   label: "BRANCH",
        // },

        {
          key: "pay_mode",
          sortable: true,
          label: "PAYMENT MODE",
        },
        {
          key: "cr",
          label: "CR",
        },
        {
          key: "dr",
          label: "DR",
        },

        {
          key: "description",
          sortable: true,
          label: "NARATION",
        },
      ],
      //   ============================= EXPORT ==============================
      json_fields: {
        DATE: "date",
        BRANCE: "branch",
        PAYMENT_MODE: "pay_mode",
        CR: "transcr",
        DR: "transdr",
        NARATION: "description",
        // TOTAL_INCOME: "total_inc",
        // TOTAL_EXPENDITURE: "total_exp",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },

  computed: {
    // MAP STATE
    ...mapState("reports", ["cashflow"]),
    ...mapGetters("reports", ["Cashflow"]),
    ...mapGetters("payments", ["PaymentModes"]),

    rows() {
      return this.fitered_array ? this.fitered_array.length : 1;
    },
  },
  watch: {
    cashflow(newValue) {
      if (newValue.length > 0) {
        this.setcashflowData();
      }
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Cashflow ? this.Cashflow.length : 1;
  },
  methods: {
    ...mapActions({
      FetchCashFlow: "reports/fetchCashFlow",
      FetchPaymentModes: "payments/fetchPaymentModes",
    }),

    setcashflowData() {
      this.fitered_array = this.Cashflow;
      let total_inc = 0;
      let total_exp = 0;
      this.fitered_array.forEach((value) => {
        if (value.transaction_type == 1) {
          let total1 = value.amount;
          let total2 = total1.replaceAll(",", "");
          let total = parseInt(total2);
          total_inc = total_inc + total;
        } else {
          let total1 = value.amount;
          let total2 = total1.replaceAll(",", "");
          let total = parseInt(total2);
          total_exp = total_exp + total;
        }
      });
      this.rep_total.inc_total = this.thousandSeprator(total_inc);
      this.rep_total.exp_total = this.thousandSeprator(total_exp);
      this.rep_total.balance = this.thousandSeprator(total_inc-total_exp);
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    localizeDate(date) {
      if (!date || !date.includes("-")) return date;
      const [yyyy, mm, dd] = date.split("-");
      return new Date(`${mm}/${dd}/${yyyy}`);
    },
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    Excel_export() {
      axios
        .post("export_cashflow", this.filterCashflow, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", "cashflow.xlsx");
          document.body.appendChild(fileLink);
          fileLink.click();
          this.$toast.add({
            severity: "success",
            summary: "Successful",
            detail: "Cashflow Report Downloaded successfully",
            life: 6000,
          });
          this.spinner = false;
        })
        .catch(() => {
          this.spinner = false;
          this.$toast.add({
            severity: "error",
            summary: "Something wrong",
            detail: "Cashflow Report Download failed",
            life: 6000,
          });
        });
    },
    filter_report() {
      let startDate = this.localizeDate(this.filterCashflow.datefrom);
      let endDate = this.localizeDate(this.filterCashflow.dateto);
      let total_inc = 0;
      let total_exp = 0;
      if (startDate != "" && endDate != "" && this.filterCashflow.mode == "") {
        this.filterCashflow.title =
          "CASHFLOW REPORT FROM <b class='text-primary'>" +
          this.filterCashflow.datefrom +
          " </b> TO <b class='text-primary'>" +
          this.filterCashflow.dateto +
          "</b>";
        this.fitered_array = this.Cashflow.filter((pymts) => {
          if (
            this.localizeDate(pymts.filter_date) >= startDate &&
            this.localizeDate(pymts.filter_date) <= endDate
          ) {
            if (pymts.transaction_type == 1) {
              let total1 = pymts.amount;
              let total2 = total1.replaceAll(",", "");
              let total = parseInt(total2);
              total_inc = total_inc + total;
            } else {
              let total1 = pymts.amount;
              let total2 = total1.replaceAll(",", "");
              let total = parseInt(total2);
              total_exp = total_exp + total;
            }
            return (
              this.localizeDate(pymts.filter_date) >= startDate &&
              this.localizeDate(pymts.filter_date) <= endDate
            );
          }
        });
      } else if (startDate != "" && endDate != "" && this.filterCashflow.mode != "") {
        this.fitered_array = this.Cashflow.filter((pymts) => {
          if (
            this.localizeDate(pymts.filter_date) >= startDate &&
            this.localizeDate(pymts.filter_date) <= endDate &&
            pymts.mode_id == this.filterCashflow.mode
          ) {
            this.filterCashflow.title =
              "CASHFLOW REPORT FROM <b class='text-primary'>" +
              this.filterCashflow.datefrom +
              " </b> TO <b class='text-primary'>" +
              this.filterCashflow.dateto +
              "</b> FOR <b class='text-primary'>" +
              pymts.pay_mode +
              "</b>";

            if (pymts.transaction_type == 1) {
              let total1 = pymts.amount;
              let total2 = total1.replaceAll(",", "");
              let total = parseInt(total2);
              total_inc = total_inc + total;
            } else {
              let total1 = pymts.amount;
              let total2 = total1.replaceAll(",", "");
              let total = parseInt(total2);
              total_exp = total_exp + total;
            }
            return (
              this.localizeDate(pymts.filter_date) >= startDate &&
              this.localizeDate(pymts.filter_date) <= endDate &&
              pymts.mode_id == this.filterCashflow.mode
            );
          }
        });
      } else if (startDate == "" && endDate != "" && this.filterCashflow.mode != "") {
        this.fitered_array = this.Cashflow.filter((pymts) => {
          if (
            this.localizeDate(pymts.filter_date) <= endDate &&
            pymts.mode_id == this.filterCashflow.mode
          ) {
            this.filterCashflow.title =
              "CASHFLOW REPORT </b> FOR <b class='text-primary'>" +
              pymts.pay_mode +
              "</b>";
            if (pymts.transaction_type == 1) {
              let total1 = pymts.amount;
              let total2 = total1.replaceAll(",", "");
              let total = parseInt(total2);
              total_inc = total_inc + total;
            } else {
              let total1 = pymts.amount;
              let total2 = total1.replaceAll(",", "");
              let total = parseInt(total2);
              total_exp = total_exp + total;
            }
            return (
              this.localizeDate(pymts.filter_date) <= endDate &&
              pymts.mode_id == this.filterCashflow.mode
            );
          }
        });
      } else {
        this.fitered_array = this.Cashflow;
      }

      this.rep_total.inc_total = this.thousandSeprator(total_inc);
      this.rep_total.exp_total = this.thousandSeprator(total_exp);
      this.rep_total.balance = this.thousandSeprator(total_inc-total_exp);
    },
  },
  created() {
    this.setcashflowData();
    this.FetchCashFlow();
    this.FetchPaymentModes();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h3 class="card-title mb-2 text-center" v-html="filterCashflow.title"></h3>
            <div class="row">
              <div class="col-md-4 form-group">
                <label>FROM</label>
                <input
                  @change="filter_report()"
                  type="date"
                  v-model="filterCashflow.datefrom"
                  class="form-control m-1"
                />
              </div>
              <div class="col-md-4 form-group">
                <label>TO</label>
                <input
                  @change="filter_report()"
                  v-model="filterCashflow.dateto"
                  type="date"
                  class="form-control m-1"
                />
              </div>
              <div class="col-md-4 form-group">
                <label>PAYMENT MODE</label>
                <model-list-select
                  @input="filter_report()"
                  :list="PaymentModes ? PaymentModes : []"
                  v-model="filterCashflow.mode"
                  option-value="id"
                  option-text="mode"
                  placeholder="select pyment mode"
                  required
                >
                </model-list-select>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <b-button variant="primary" @click="Excel_export()"
                  ><i class="fa fa-download"></i>Export</b-button
                >
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                foot-clone
                class="datatables"
                :items="fitered_array ? fitered_array : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(actions)="data">
                  <button @clinc="yes(data)" class="btn btn-primary btn-sm">
                    Details
                  </button>
                </template>
                <template #cell(cr)="data">
                  {{ data.item.transaction_type == 1 ? data.item.amount : "--" }}
                </template>
                <template #cell(dr)="data">
                  {{ data.item.transaction_type == 0 ? data.item.amount : "--" }}
                </template>
                <template #foot(cr)="">
                  Inc
                  <span class="text-danger">{{ rep_total.inc_total }}</span>
                </template> 
                <template #foot(dr)="">Exp
                  <span class="text-danger"> {{ rep_total.exp_total }}</span>
                </template>
                <template #foot(pay_mode)="">
                  <span class="text-danger"></span>
                </template>

                branch

                <template #foot(date)="">
                  <span class="text-danger"></span>
                </template>
                <template #foot(branch)="">
                  <span class="text-danger"></span>
                </template>
                <template #foot(description)="">
                  Balance: 
                  <span class="text-danger">{{ rep_total.balance }}</span>
                </template>
              </b-table>

              <center>
                <h3 v-if="!Cashflow" class="text-primary">
                  <b-spinner class="m-0" letiant="primary" role="status"></b-spinner>
                  Please wait...
                </h3>
              </center>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
